import LayoutOpen from 'components/Content/ContentLayout/LayoutOpen/LayoutOpen';

export default LayoutOpen;
